import { NUMBER_1, NUMBER_2 } from '~shared/constants';

export namespace GridHeightUtil {
  export function getGridMaxHeight(listLength: number, columnsPerRow: number, gridGap: number, columnHeight): number {
    const rows = Math.ceil(listLength / columnsPerRow);
    const gap = (rows - NUMBER_1) * gridGap;
    return rows * columnHeight + gap;
  }

  export function getGridMinHeight(columnHeight: number, gridGap: number): number {
    return NUMBER_2 * columnHeight + gridGap;
  }
}
